import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'nodelist',
    styleUrls: ['./tree.css'],
    template: `
<li>
	<a style="cursor:pointer" [class.selected]="item.selected">  
        <span *ngIf="item.Children&&item.IsExpanded" class="expand-button" (click)="toggle($event, item)"><i class="fa fa-folder-open"></i></span>
        <span *ngIf="item.Children&&!item.IsExpanded" class="expand-button" (click)="toggle($event, item )"><i class="fa fa-folder"></i></span>        
        
        <span *ngIf="IsExpanded&&!item.Children" class="expand-button" (click)="toggle($event, item)"><i class="fa fa-file-o"></i></span>                
        
        <input *ngIf="IsMultiSelected" type='checkbox' [(ngModel)]="item.selected" (change)="onSelectMulti(item)" />
        <span (click)="onSelectSingleNode(item)" [class.selected]="item.selected" [class.haschild]="item.Children" >{{item.name}}</span>
    </a>
	<div [hidden]="!(item.IsExpanded && item.Children)" class="subtree">
        <treelist [data]="item.Children" [subtree]="true"
            [Level]="Level"
            [IsExpanded] = "IsExpanded"
            [IsMultiSelected] = "IsMultiSelected" 
            [selectedNodeTrue] = "selectedNodeTrue"
            [selectedNode]="selectedNode"
            (selectedNodeChange)="OnSelectedNodeChange($event)"
            [selectedNodes]="selectedNodes"
            (selectedNodesChange)="OnSelectedNodesChange($event)">
        </treelist>
    </div>
</li>
`
})
export class Nodelist implements OnInit {
    @Input() Level:any = 1;
    @Input() IsMultiSelected: boolean;
    @Input() IsExpanded: boolean;
    @Input() item: any;

    @Input() selectedNode: any;

    @Input() selectedNodeTrue: boolean;
    @Output() selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();

    @Input() selectedNodes: any[] =[];
    @Output() selectedNodesChange: EventEmitter<any[]> = new EventEmitter<any[]>();

    ngOnInit() {
        if(this.selectedNodeTrue == true)
        {
            this.item.selected = true;
            this.checkHelper(this.item, true)
        }
        if (this.selectedNodes == undefined)
            this.selectedNodes = [];
    }

    toggle($event, item) {       
        item.IsExpanded = !item.IsExpanded;
        if (this.IsExpanded)
            this.Level = 0;
        $event.stopPropagation();
    }

    OnSelectedNodeChange($event) {
        this.selectedNodeChange.emit($event);
    }

    OnSelectedNodesChange($event) {
        this.selectedNodesChange.emit($event);
    }

    onSelectSingleNode(node) {
        this.item.selected = true;
        this.selectedNode = node;
        this.selectedNodeChange.emit(this.selectedNode);
    }
    checkHelper(node, flag) {
        if (node.Children) {
            let self = this;
            node.Children.forEach(function (subNode) {
                subNode.selected = flag;
                self.checkHelper(subNode, flag);
            });
        }
    }
    onSelectMulti(node) {        
        if (this.item.selected) {
            this.selectedNodes.push(node);
        }
        else {
            for (let i = 0; i < this.selectedNodes.length; i++) {
                if (this.selectedNodes[i].id == node.id) {                    
                    this.selectedNodes.splice(i, 1);
                    break;
                }            
            }
        }
        this.checkHelper(node, node.selected);
        this.selectedNodesChange.emit(this.selectedNodes);
    }
}

@Component({
    selector: 'treelist',
    styleUrls: ['./tree.css'],
    template: `
<ul class='tree' *ngFor="let it of data">
    <nodelist [item]="it"
        [Level]="Level-1"
        [IsExpanded] = "IsExpanded"
        [selectedNodeTrue] = "selectedNodeTrue"
        [IsMultiSelected] = "IsMultiSelected" 
        [selectedNodes] = "selectedNodes"
        (selectedNodesChange)="selectMultiNode($event)"
        [selectedNode]="selectedNode"
        (selectedNodeChange)="selectSingleNode($event)">
    </nodelist>
</ul>
`,

})
export class Treelist implements OnInit {
    @Input() Level:any = 1;
    @Input() IsMultiSelected: boolean;
    @Input() data: any[];
    @Input() subtree: boolean;
    @Input() IsExpanded: boolean;
    @Input() selectedNodeTrue: boolean;
    @Input() selectedNode: any;
    @Output() selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();

    @Input() selectedNodes: any[]=[];
    @Output() selectedNodesChange: EventEmitter<any[]> = new EventEmitter<any[]>();

    ngOnInit() {
        if (this.IsExpanded == undefined)
            this.IsExpanded = true;
        if (this.subtree == undefined)
            this.subtree = false;
        if (this.selectedNodes == undefined)
            this.selectedNodes = [];

    }

    selectMultiNode(eventData: any[]) {
        this.selectedNodes = eventData;
        this.selectedNodesChange.emit(this.selectedNodes);
    }

    selectSingleNode(nodeData: any) {
        this.unSelecttreelist(this.data, nodeData.id);
        this.selectedNode = nodeData;
        this.selectedNodeChange.emit(this.selectedNode);
    }

    unSelecttreelist(data: any[], id_exclude: any) {
        for (let i = 0; i < data.length; i++) {
            if (data[i].id != id_exclude) {
                data[i].selected = false;
            }
            if (data[i].Children) {
                this.unSelecttreelist(data[i].Children, id_exclude);
            }
        }
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/directives/treelist.ts